<template>
    <table :class="tableClasses">
        <thead @click="open = ! open" :class="headClasses">
            <slot name="head"></slot>
        </thead>
        <transition enter-active-class="transition ease-out duration-300"
                    enter-from-class="transform opacity-0"
                    enter-to-class="transform opacity-100"
                    leave-active-class="transition ease-in duration-150"
                    leave-from-class="transform opacity-100"
                    leave-to-class="transform opacity-0">
            <tbody v-show="open" :class="bodyClasses">
                <slot name="body"/>
            </tbody>
        </transition>
    </table>
</template>

<script>
export default {
    name: "CollapsableTable",
    props: {
        tableClasses: {
            type: String,
        },
        headClasses: {
            type: String,
        },
        bodyClasses: {
            type: String,
        },
    },
    data() {
        return {
            open: false,
        };
    },
};
</script>
